import React, {Component} from 'react';
import './profile-card.scss'
import { Tooltip } from 'antd';
export default class ProfileCard extends  Component < any, any> {
    state = {
        tooltipMessge:'',
        priceType:'USD',
        loading:false,
        Data:[],
        DataProfile:null
    };

    getEngagement(){

        return (Number((+this.props.data.average_likes) + (+this.props.data.average_comments))/(+this.props.data.followers_count)*100).toFixed(2);

    }
    transformDecimal(num :any) {

        if(num === undefined)
        {
            return 'N/A';
        }
        let n = parseInt(num);
        if(n === 0)
        {
            return 0;
        }
        const rx =  /(\d+)(\d{3})/;
        return String(n).replace(/^\d+/, function (w) {
            let res = w;
            while (rx.test(res)) {
                res = res.replace(rx, '$1,$2');

            }

            return res;
        });

    }
    suggestedOffer(value:any){
        if(value>=250000)
        {
            this.setState({ tooltipMessge: 'An audience of +250k typically commands a custom rate by person so we suggest requesting a Rate Card per collaboration.' });
            return 'Ask for Rates'
        }
        else if(value>=100000 && value<250000 )
        {

            if(this.state.priceType=='USD'){
                this.setState({ tooltipMessge: 'An audience of 100k-250k typically involves $350-$500 and the product/service' });
                return '$350 - $500 '
            }
            if(this.state.priceType=='Euro'){
                this.setState({ tooltipMessge: 'An audience of 100k-250k typically involves €316 - €452 and the product/service'});
                return '€316 - €452 '
            }
            if(this.state.priceType=='Pound'){
                this.setState({ tooltipMessge: 'An audience of 100k-250k typically involves £266 - £380 and the product/service'});
                return '£266 - £380 '
            }

        }
        else if(value>=55000 && value<100000 )
        {



            if(this.state.priceType=='USD'){
                this.setState({ tooltipMessge: 'An audience of 55k-100k typically involves $200-$350 and the product/service '});
                return '$200 - $350'
            }
            if(this.state.priceType=='Euro'){
                this.setState({ tooltipMessge: 'An audience of 55k-100k typically involves €180 - €316 and the product/service '});
                return '€180 - €316'
            }
            if(this.state.priceType=='Pound'){
                this.setState({ tooltipMessge: 'An audience of 55k-100k typically involves £152 - £266  and the product/service '});
                return '£152 - £266 '
            }
        }
        else if(value>=25000 && value<50000 )
        {



            if(this.state.priceType=='USD'){
                this.setState({ tooltipMessge: ' An audience of 25k-50k typically involves $100-$200 and the product/service'});
                return '$100 - $200'
            }
            if(this.state.priceType=='Euro'){
                this.setState({ tooltipMessge: ' An audience of 25k-50k typically involves €90 - €181 and the product/service'});
                return '€90 - €181 '
            }
            if(this.state.priceType=='Pound'){
                this.setState({ tooltipMessge: ' An audience of 25k-50k typically involves £76 - £152  and the product/service'});
                return '£76 - £152 '
            }
        }
        else if(value>=10000 && value<25000 )
        {



            if(this.state.priceType=='USD'){
                this.setState({ tooltipMessge: 'An audience of 10k-25k typically involves $100-$150 and the product/service '});
                return '$100 - $150'
            }
            if(this.state.priceType=='Euro'){
                this.setState({ tooltipMessge: 'An audience of 10k-25k typically involves €90 - €135  and the product/service '});
                return '€90 - €135 '
            }
            if(this.state.priceType=='Pound'){
                this.setState({ tooltipMessge: 'An audience of 10k-25k typically involves £46 - £114 and the product/service '});
                return '£46 - £114 '
            }
        }
        else if(value>=0 && value<10000 )
        {



            if(this.state.priceType=='USD'){
                this.setState({ tooltipMessge: 'An audience of 1k-10k typically involves a straight barter for product/service and/or $25-$75 per collaboration and the product/service. '});
                return '$25 - $75'
            }
            if(this.state.priceType=='Euro'){
                this.setState({ tooltipMessge: 'An audience of 1k-10k typically involves a straight barter for product/service and/or €23 - €68  per collaboration and the product/service. '});
                return '€23 - €68 '
            }
            if(this.state.priceType=='Pound'){
                this.setState({ tooltipMessge: 'An audience of 1k-10k typically involves a straight barter for product/service and/or £19 - £57 per collaboration and the product/service. '});
                return '£19 - £57 '
            }
        }
    }
    likeAndRatio(average_comments:any,average_likes:any){
        let a_comments;
        if(average_comments)
        {
            a_comments=average_comments;
        }
        else {
            a_comments=average_comments;
        }



        let a_likes;
        if(average_likes)
        {
            a_likes=average_likes;
        }
        else {
            a_likes=average_likes;
        }


        if(a_likes>a_comments)
        {
            return  (1) +' : '+Math.round(a_likes/a_comments);
        }
        else if(a_likes==a_comments)
        {
            return  (1) +' : '+(1);
        }
        else if(a_likes<a_comments)
        {

            return Math.round(a_comments/a_likes)  +' : '+ (1) ;
        }
    }
    setEngagmentStatus(value:any){

        if(value<2)
        {
            return 'Below Average'
        }
        if(value>=2 && value<6)
        {
            return 'Average'
        }
        if(value>=6 && value<10)
        {
            return 'Good'
        }
        if(value>=10)
        {
            return 'Very Good'
        }

    }
     createMarkup(body:any) {
        return {__html: body.slice(0, 235)};
    }
    copyMessage(val: string){
        let selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }
  render() {
    
    
    console.log(this.props)
      const { data} = this.props;
 
    return (
      <div className="page-profile-card">
          <div  className="relative-container">
              <div className="profile">
                  <div className="profile-top-level">
                      <div className="user-basics">
                          <div className="user-avatar">
                              <a  href={'//www.instagram.com/'+data.username} target="_blank">
                                  <img
                                                                                                                                  src={data.avatar_url} className="avatar"
                                                                                                                                  alt=""/></a></div>
                      </div>
                  </div>


                  <div className="user-container" >

      <div className="user-details">

     
        <div>
            {
                data.tagline ? (
                    <p className="tagline" dangerouslySetInnerHTML={this.createMarkup(data.tagline)} >

                    </p>
                ):''
            }

            

        </div>

          <ul className="profile-stat-labels">
              <div className="stat-flex">


                  <p className="stat-label">Engagement


                  </p>


                  <div className="stat-count "><p className="stat-count-first-line">
                      {this.getEngagement()}
                    <span className="engagement-percent-symbol">%</span></p>
                      <p className="smallcaps" >
                          
                      </p></div>
              </div>
              <div className="stat-flex"><p className="stat-label">Followers</p>
                  <p className="stat-count">{this.transformDecimal(data.followers_count)}</p></div>





              <div className="stat-flex"><p className="stat-label">Posts</p>
                  <p className="stat-count">{this.transformDecimal(data.posts_count)}</p></div>
          </ul>


      </div>


      <div className="averages">
          <div className="view-details-container"><span
              className="detail-action-button view-more-details-btn" >View more details</span></div>
        <div className="stat-flex"><p className="stat-label">Averages Per Post</p>
          <ul className="profile-stats">
            <li className="stat-count"><p title="Average Likes Per Post"><span className=""><i className="mdi mdi-heart fa-fw"
                                                                                       ></i>
       {this.transformDecimal(data.average_likes )}</span></p></li>
      <li className="stat-count"><p title="Average Comments Per Post"><span className=""><i className="mdi mdi-comment fa-fw"
                                                                                   ></i>
        {this.transformDecimal(data.average_comments) }</span></p></li>
      <li className="stat-count"><p title="Average Video Views Per Post"><span className=""><i
          className="mdi mdi-video fa-fw" ></i>{this.transformDecimal(data.average_video_views)}
        </span></p></li>
  </ul>
  </div>
      <li className="comment-like-ratio"><span className=""><i className="mdi mdi-scale-balance fa-fw"
                                                       ></i>
        </span><span className="strong pr-5">{this.likeAndRatio(data.average_comments,data.average_likes)}</span>
       <span>Comment : Like
           Ratio</span>
        <span className="stat-tooltip"><span className="stat-count-multiline gradient-1 row">
            {this.setEngagmentStatus(data.average_engagement_percentage)}
          


                <Tooltip title="This is a rolling average calculated on how many comments a piece of content recieves per like. A good ratio indicates a more engaged, loyal fanbase. A bad ratio may indicate a weaker audience and potentially fake likes. We factor the amount of followers an account has when calculating the determination.">
   <i
       className="mdi mdi-information-outline font-15">

            </i>
  </Tooltip>

           </span></span></li>
      </div>
      <div className="traits">
          {data.country ? (
              <li   className="location" ><span ><i className="mdi mdi-map-marker-radius fa-fw" ></i>
        Content mostly from {data.country} </span>  </li>
          ):''}


          {data.external_link ? (
              <li  className="external-link"><span className=""><i className="mdi mdi-link-variant fa-fw"
              />
      </span><a href={data.external_link}
                rel="noreferrer noopener nofollow" target="_blank">{data.external_link}</a>
              </li>
          ):''}

          {data.email ? (
              <li className="email-from-blurb" >
                  <div className="email-wrapper"><span className=""><i className="mdi mdi-email-outline fa-fw"
                  ></i>
                      {data.email}</span></div>

                  <span className="stat-tooltip"><div className="tooltip-item undefined"><span className="trigger"><span
                      className="copy-paste-email" ><span
                      className="copy-text"><span className=""><i className="mdi mdi-content-copy" ></i>
      Copy</span></span></span></span><span><span
                  ></span></span></div></span></li>
          ):''}



          <li className="mentions-list"><span className="strong text-bold pr-10">Top mentions
          </span>
              {data.mentions && (
                  <div>
                      {data.mentions.map((mention:any, index:any) =>
                              <span key={index+mention} ><a
                                  href={'//www.instagram.com/' + mention.slice(1, mention.length)}
                                  className="profile-link"
                                  target="_blank">{mention}</a> ,
                  </span>
                      )}
                  </div>

              )}
             </li>

          <li className="hashtags"><span className="strong text-bold pr-10">Top hashtags :
          </span>
              {data.hashtags && (
                  <div>
                      {data.hashtags.map((hashtag:any, index:any) =>
                              <span key={index+hashtag} ><a
                                  href={'//www.instagram.com/explore/tags/' + hashtag}
                                  className="profile-link"
                                  target="_blank">#{hashtag}</a> ,
                  </span>
                      )}
                  </div>

              )}
          </li>

          <li className="mentions-list"><span className="strong text-bold pr-10">Mentioned With:
          </span>
              {data.mentionsWith && (
                  <div>
                      {data.mentionsWith.map((mention:any, index:any) =>
                              <span key={index+mention} ><a
                                  href={'//www.instagram.com/' + mention.slice(1, mention.length)}
                                  className="profile-link"
                                  target="_blank">{mention}</a> ,
                  </span>
                      )}
                  </div>

              )}
          </li>




























  </div>
  </div>


                  {data.posts.length>0 && (

                      <ul  className="media-gallery">
                          <div className="media-flex-parent">

                              {data.posts.map((post:any, index:any) =>
                                  <li key={index+post.code}   className="media-container" >
                                  <div className="media-image">



                                  <a className="media-image-anchor"  href={'//www.instagram.com/p/'+post.code}  target="_blank">
                                  <img  src={post.thumbnail_url} className="media-image-object"/>
                                  </a>
                                      {

                                      }

                                  <div className="media-meta hidden-for-mobile"><span className="likes-meta"><span className=""><i className="mdi mdi-heart"
                                 ></i>
                                  {this.transformDecimal(post.likes_count)}</span></span><span
                                  className="comments-meta pr-10"><span
                                  className=""><i className="mdi mdi-comment" ></i>{this.transformDecimal(post.comments_count)}
                                  </span></span></div>
                                  </div>
                                  </li>
                              )}



                      </div>
                      </ul>
                    )}

                  
                  
      <div className="profile-insights-animation-wrapper relative-container"></div>
  </div>
  </div>




  </div>
    )
  }
}